/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { notify } from "notiwind";

export default {
  types: {
    INPUT_ERROR: "Eingabefehler",
    ERROR: "Fehler"
  },
  success(message) {
    this.notify("success", message, "Erfolgreich");
  },
  error(message, type = "Fehler") {
    this.notify("error", message, type);
  },
  notify(status, message, type = undefined) {
    const notification = {
      group: status,
      text: message
    };

    if (type)
      notification.title = type;

    notify(notification, 5000); // 5s
  }
};